import { createIntl } from "react-intl";
import { getLanguage } from "co-addin-captions";
import { selectCpmUser } from "../../redux/feature/settings/configurations-slice";
import { store } from "../../redux/store/store";
import React from "react";
import { LinkedDocumentInfo } from "../../api/models/linked-document-info";

let intl;

function initIntl() {
  let selectedCpmUser = selectCpmUser(store.getState());
  if (selectedCpmUser) {
    intl = createIntl({
      locale: selectedCpmUser.preferredLanguage,
      messages: getLanguage(selectedCpmUser.preferredLanguage),
    });
    return intl;
  }
  if (global.Office?.context?.displayLanguage) {
    return createIntl({
      locale: global.Office.context.displayLanguage,
      messages: getLanguage(global.Office.context.displayLanguage),
    });
  }
}

export const descriptionLanguage = () => {
  let selectedCpmUser = selectCpmUser(store.getState());
  if (selectedCpmUser) {
    // TODO va presa la descriptionLanguage, vedi IDS-1039
    const language = selectedCpmUser.preferredLanguage.split("-");
    return language[0];
  }
  return null;
};

export function formatMessage(id: string) {
  if (!id) return "";
  const intlToUse = intl ?? initIntl();
  return intlToUse ? intlToUse.formatMessage({ id: id }) : id;
}

export function multiline(message: string): React.ReactNode {
  return message.split(/\\n|\r?\n/).map((line, idx, arr) => (
    <React.Fragment key={idx}>
      {line}
      {idx < arr.length - 1 && <br />}
    </React.Fragment>
  ));
}

export function formatSehorseLastUpdateDate(date: LinkedDocumentInfo[], driveItemId: string) {
  let seahorseDocumentLinked = date?.find((item) => item?.driveItemId === driveItemId);
  if (!seahorseDocumentLinked) return "";
  return formatMessage("cof.seahorse.sent") + " " + formateDateToPreferredLanguage(seahorseDocumentLinked.date);
}

export function formateDateToPreferredLanguage(date: Date) {
  if (!date) return "";
  let selectedCpmUser = selectCpmUser(store.getState());
  return new Intl.DateTimeFormat(selectedCpmUser.preferredLanguage, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  }).format(date);
}

export function getPreferredLanguage(): string | undefined {
  return selectCpmUser(store.getState())?.preferredLanguage ?? global.Office?.context?.displayLanguage;
}

export function formatMessageWithParams(id: string, params) {
  if (!id) return "";
  const intlToUse = intl ?? initIntl();
  return intlToUse ? intlToUse.formatMessage({ id: id }, params) : id;
}

export function formatMessageWithParamsDefault(id: string, defaultMessage: string, params) {
  if (!id) return "";
  const intlToUse = intl ?? initIntl();
  return intlToUse ? intlToUse.formatMessage({ id: id, defaultMessage: defaultMessage }, params) : id;
}

export function tryFormatMessageWithJson(jsonInput: string) {
  if (!jsonInput) return "";
  try {
    let caption = JSON.parse(jsonInput);
    const intlToUse = intl ?? initIntl();
    return intlToUse ? intlToUse.formatMessage({ id: caption.key }, caption.params) : caption.key;
  } catch {
    return jsonInput;
  }
}

export function formatMessageDefault(id: string, defaultMessage: string) {
  if (!id) return "";
  if (intl == null) initIntl();
  return intl ? intl.formatMessage({ id: id, defaultMessage: defaultMessage }) : id;
}

export const escapeWithBreakLineAndTranslate = (data: string) => {
  return data
    .replace(/\$@(.*?)@\$/g, (_, s) => formatMessage(s))
    .split("||")
    .reduce((acc, v) => {
      acc.push(...v.split("<b>").map((v, i) => (i % 2 ? <b key={v + i}>{v}</b> : v)), <br />);
      return acc;
    }, [])
    .slice(0, -1);
};
export const getFormattedValue = (value: string | boolean | number) => {
  if (typeof value === "string") return value;
  if (typeof value === "number") return value.toString();
  if (typeof value === "boolean") return value ? "true" : "false";
  if (!value) return "";
  if (typeof value === "object") return JSON.stringify(value);
  return "UNHANDLED VALUE";
};
